<template>
  <v-dialog v-model="dialog" max-width="650">
    <template v-slot:activator="{ on, attrs }">
      <v-img
        v-bind="attrs"
        v-on="on"
        style=""
        max-width="700"
        width="100%"
        ref="imgEvent"
        :src="mapUrl"
        class="map__img"
        alt="Evento"
      />
    </template>

    <v-card>
      <v-card-title class="mb-4">
        <v-row no-gutters justify="space-between">
          <span>{{ $t("cart.locationMap") }}</span>
          <v-icon @click="dialog = false">mdi-close</v-icon>
        </v-row>
      </v-card-title>

      <v-card-text>
        <v-row justify="center" no-gutters>
          <v-img
            style=""
            max-width="700"
            width="100%"
            ref="imgEvent"
            class="map__img"
            :src="mapUrl"
            alt="Evento"
          />
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["mapUrl"],
  data() {
    return {
      dialog: false,
    };
  },
};
</script>
